<template>
    <section class="background-image pb-20 overflow-hidden">
        <div class=" mt-40 ">
            <div class=" w-1/2 m-auto md:w-full">
                <div>
                    <img class=" w-1/2 m-auto" src="https://res.cloudinary.com/https-carrygo-com/image/upload/v1634105033/carrygoWebAssets/carrygo_logo_vrdtw8.svg" alt="logo">
                    <p class="font-nunitosans text-2xl text-gray-400 text-center">ADMIN</p>
                </div>

                <div class=" w-4/5 m-auto  font-poppins mt-8">
                 <div class="mt-8 font-semibold text-center text-lg text-blue-600">
                    <p>RESET PASSWORD</p>
                </div>
                <!-- <p class="text-green-500">{{message}}</p> -->
                   <!-- Email VERIFICATION -->
                            <div>
                                <form @submit.prevent="_verifyEmail">
                                   
                                    <p class="text-xs text-green-500" v-show="isCodeSent">reset link sent successfully. Please check your email.</p>
                                    <p class="text-xs text-red-500" v-show="codeFailed">reset link was not sent. Try again</p>
                                    <div class="mt-5">
                                        <label for="phone">Enter Email Address</label> <br>
                                        <div class="mt-3">
                                            <input class="w-full border bg-gray-100 p-2 rounded-lg text-sm" type="email" name="email" id="email" placeholder="Enter email" v-model="email">
                                            <p v-if="emailValidity == 'invalid' " class="text-xs text-red-500">Please enter your email address</p>
                                            <p class="text-sm text-red-500">{{displayError}}</p>
                                        </div>

                                        <div class="mt-4 text-blue-600">
                                            <router-link to="/admin/login">Login</router-link>
                                        </div>
                                        <div class="mt-10 flex">
                                            <button class="w-full text-white rounded p-1" style="background-color:rgb(18,84,179)">Proceed</button>
                                            <p v-if="isLoading" class="ml-2 mt-2 animate-spin rounded-full h-6 w-6 border border-t-2 border-b-2 border-blue-900 "></p>
                                        </div>

                                    </div>
                                </form>
                            </div>

                        </div>      
                    </div>  
                </div>
        
        
        
    </section>
</template>

<script>
import axios from 'axios';
import {baseUrl} from '../../Config';
const url = baseUrl;
export default {
    components: {
    },
    data() {
        return {
            isLoading: false,
            resetPassword: true,
            displayError: "",
            isCodeSent: false,
            codeFailed:false,
            email: "",
            emailValidity:"",
            message: ""
        }
    },

    mounted() {
        this.networkError();
    },

    methods: {
       
        _verifyEmail() {
            this.$store.dispatch("resetEmail", this.email)
            if(!this.email) {
                this.emailValidity = "invalid"
            } else {
                this.isLoading = true
                axios({
                method: 'POST',
                url: `${url}/v1/web/auth/forgot-password`,
                headers: {
                    'Content-type': 'application/json',
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
                data: {
                    email: this.email
                }
                })
                .then((res) => {
                    res.json;
                    this.isCodeSent = true;
                    this.isLoading = false
                })
                .catch(err => {
                    err;
                    this.codeFailed = true;
                 setTimeout(() => {
                    this.codeFailed = false;
                }, 3000);
                    this.displayError = err.response.data.message
                    this.isLoading = false
                })
            }
        },

        networkError() {
            if(!navigator.onLine) {
                this.$router.push('/network-error')
            } 
        }
    }
}
</script>

<style scoped>
.background-image {
    background-image:linear-gradient(rgba(255, 255, 255, 0.6), rgba(255,255,255,0.5)), url('../LandingPages/Images/image 27.png');
    background-repeat: no-repeat;    
    background-size: cover;
}
</style>